module.exports = __webpack_public_path__ + "img/recently-used.f89e2dbb.svg";